module.exports = __webpack_public_path__ + "img/premium.4a45a287.jpg";